<template>
    <tr class="tableTr">
        <td class="" :class="{'tdGreen': checkClasses['filter_createdDate']}">{{ item['createdDate'] }}</td>
        <td class="" :class="{'tdGreen': checkClasses['filter_createdBy']}">{{ item['createdBy'] }}</td>
        <td class="" :class="{'tdGreen': checkClasses['filter_period']}">{{ item['period'] }}</td>
        <td class="" :class="{'tdGreen': checkClasses['filter_renewal']}">{{ item['renewal'] }}</td>
        <td class="" :class="{'tdGreen': checkClasses['filter_notes']}">{{ item['note'] }}</td>
        <td width="90">
            <div class="btnGroups">
                <button :disabled="getPermissionAction" type="button" @click="onEdit">
                    <svg-sprite icon-id="edit" width="18" height="18"></svg-sprite>
                </button>
                <button :disabled="getPermissionAction" type="button" @click="onRemove">
                    <svg-sprite icon-id="deleteItem" width="20" height="20"></svg-sprite>
                </button>
            </div>
        </td>
    </tr>
</template>

<script>
export default {
	name: "TableTr",
	props: {
		item: Object,
		checkClasses: Object,
		getPermissionAction: Boolean
	},
	methods: {
		onEdit() {
			this.$emit('updateEdit', this.item);
		},
		onRemove() {
			this.$emit('updateRemoveItem', this.item.id);
		},
	}
};
</script>
